<template>
  <t-config-provider :global-config="globalConfig">
    <router-view :key="rootKey + 'routerViewKey'" />

    <!-- DeepSeek接口都需要登录才能用————宋柏欣 -->
    <!-- 高教展环境的需要把督导巡课平台中的deepseek按钮隐藏————邓婷 -->
    <DeepSeek v-if="shouldShowDeepSeek && hostname !== 'zhys.wxiang.com'" />
  </t-config-provider>
</template>

<script setup>
import { provide, ref, computed, watch } from "vue";
import merge from "lodash/merge";
import { getEqumentDetail } from "@/api/base.js"; // getExternalInfo
import enConfig from 'tdesign-vue-next/es/locale/en_US';// English
import zhConfig from 'tdesign-vue-next/es/locale/zh_CN';// 中文
import jpConfig from "tdesign-vue-next/es/locale/ja_JP";
import Cookies from "js-cookie";
import DeepSeek from "@/views/DeepSeek";
import { useI18n } from "vue-i18n";
import { useStore } from "vuex";

const store = useStore();
const { t } = useI18n();

let privatization = window.g.privatization; /// 是否私有化部署， true/是 false/否

const getToken = Cookies.get("tokenValue");

const shouldShowDeepSeek = computed(() => {
  return getToken && !privatization;
});

const hostname = window.location.hostname;

// 全局特性配置，引入英文语言配置包 enConfig
const rootKey = ref(1997);
const globalConfig = ref();

if (window.g.LANG === "zh") {
  globalConfig.value = merge( zhConfig);
}else if (window.g.LANG === "ja") {
  globalConfig.value = merge(jpConfig);
}else{
  globalConfig.value = merge(enConfig);
}

const language = ref(window.g.LANG);
provide("language", language);
watch(language,(newval, oldval) => {
  console.log(newval, oldval);
  if(newval != oldval){
    if (window.g.LANG === "zh") {
    globalConfig.value = merge( zhConfig);
  }else if (window.g.LANG === "ja") {
    globalConfig.value = merge(jpConfig);
  }else{
    globalConfig.value = merge(enConfig);
  }
    rootKey.value++;
  }
})
// 特殊私有化部署 处理
// getExternalInfo().then(res => {
//   if(res.code == 1){
//     let externalIp = res.data ? res.data.externalIp : "";
//     sessionStorage.setItem('enableExternal', externalIp)
//   }
// })

getEqumentDetail().then((res) => {
  if (res.code === 1) {
    let data = [];
    if(res.data.recorderVideoView == 1){
      data.push({
        label: t('baseTxt.RecorderRecording'),// "录播机录制",
        value: 1
      });
    }
    if(res.data.serverVideoView == 1){
      data.push({
        label: t('baseTxt.CameraRecording'),// "摄像机录制",
        value: 2
      });
    }
    // store.dispatch('setVideoSource', data);
    sessionStorage.setItem('TourRecordingSettings', JSON.stringify(data));
  }
});
</script>
<style lang="less">
#app {
  width: 100%;
  height: 100vh;
}
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  outline: none !important;
}
</style>
